const numberOf = (value) => {
  const parsed = Number(String(value ?? 0).replace(/[,£]/g, ""));
  return Number.isFinite(parsed) ? parsed : 0;
};

const currency = (value) => {
  const rounded = Math.round((value + Number.EPSILON) * 100) / 100;
  return Object.is(rounded, -0) ? 0 : rounded;
};

export const buildPaymentSummary = ({
  openingBalance = 0,
  totalCommission = 0,
  feesAndCharges = {},
} = {}) => {
  const opening = numberOf(openingBalance);
  const paymentCategory = numberOf(feesAndCharges?.categories?.payments);
  const additionalPayments = Math.abs(paymentCategory);
  const commission = numberOf(totalCommission);
  const advanceCharges = numberOf(feesAndCharges?.categories?.advances);
  const otherCharges =
    numberOf(feesAndCharges?.total) - advanceCharges - paymentCategory;
  const totalCharged = currency(-otherCharges);
  const payments = currency(additionalPayments);
  const advances = currency(-advanceCharges);

  return {
    openingBalance: opening,
    totalCommission: commission,
    totalCharged,
    payments,
    advances,
    balanceToPay: currency(
      opening + commission + totalCharged + payments + advances,
    ),
  };
};
